<!-- 回到顶部工具栏 -->
<template>
  <div v-show="showFixTool" class="FixTool-Component">
    <ul>
      <li class="tool-item">
        <a class="tools tools-1" href="javascript:;"></a>
        <load-box class="load-box" />
      </li>
      <li class="tool-item">
        <a class="tools tools-2" href="javascript:;"></a>
        <div class="follow-box">
          <p class="follow-box__tips">
            Try the following ways <br />to get in touch with us
          </p>
          <div class="follow-btn-box">
            <a
              class="follow-btn follow-btn-1"
              href="https://www.facebook.com/bigoliveapp/"
            ></a>
            <a
              class="follow-btn follow-btn-2"
              href="https://twitter.com/BIGOLIVEapp"
            ></a>
            <a
              class="follow-btn follow-btn-3"
              href="https://www.instagram.com/bigoliveapp/"
            ></a>
            <a
              class="follow-btn follow-btn-4"
              href="https://www.youtube.com/c/bigoliveofficial"
            ></a>
          </div>
        </div>
      </li>
      <li class="tool-item">
        <a class="tools tools-3" href="javascript:;" @click="goTop"></a>
      </li>
    </ul>
  </div>
</template>

<script>
import LoadBox from '@components/FixTool-LoadBox';

export default {
  components: {
    LoadBox
  },
  data() {
    return {
      showFixTool: false
    };
  },
  mounted() {
    document.addEventListener('scroll', this.scroll);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scroll);
  },
  methods: {
    scroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.showFixTool = scrollTop > 600;
    },
    goTop() {
      if (document.body.scrollIntoView) {
        document.body.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        const docScrollTop = document.documentElement || document.body;
        docScrollTop.scrollTop = 0;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.FixTool-Component {
  position: fixed;
  top: 80%;
  right: 6px;
  z-index: 9999;
  width: 58px;
  margin-top: -120px;
}

.tool-item {
  position: relative;
  width: 100%;
  height: 58px;
  margin-bottom: 7px;

  &:hover .load-box,
  &:hover .follow-box {
    display: block;
    animation: scale 0.5s;
  }

  .load-box {
    display: none;
    position: absolute;
    right: 58px;
    top: -88px;
    padding-right: 17px;
    transform-origin: 100% 0;
  }

  .tools {
    display: block;
    width: 100%;
    height: 100%;
    text-indent: 399px;
    overflow: hidden;
    background: #fff;
    border-radius: 3px;

    &:hover {
      background: #0dc;
    }

    &::before {
      content: '';
      position: relative;
      top: 14px;
      display: block;
      width: 28px;
      height: 31px;
      margin: auto;
    }

    &.tools-1 {
      &::before {
        background: url(~@assets/img/icon.png) 1px -866px no-repeat;
      }
      &:hover::before {
        background: url(~@assets/img/icon.png) -81px -866px no-repeat;
      }
    }

    &.tools-2 {
      &::before {
        background: url(~@assets/img/icon.png) 0 -906px no-repeat;
      }
      &:hover::before {
        background: url(~@assets/img/icon.png) -82px -906px no-repeat;
      }
    }

    &.tools-3 {
      &::before {
        background: url(~@assets/img/icon.png) 0 -947px no-repeat;
      }
      &:hover::before {
        background: url(~@assets/img/icon.png) -82px -947px no-repeat;
      }
    }
  }

  .follow-box {
    position: absolute;
    top: 0;
    right: 71px;
    display: none;
    width: 175px;
    height: 99px;
    box-sizing: content-box;
    transform-origin: 100% 0;
    background: #fff;

    &::before {
      content: '';
      position: absolute;
      top: 10px;
      right: -5px;
      display: block;
      width: 15px;
      height: 15px;
      transform: rotate(45deg);
      background: #fff;
    }

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
      right: -12px;
      height: 99px;
      width: 20px;
    }

    &__tips {
      padding: 12px 0px;
      box-sizing: content-box;
      text-align: center;
      font-size: 14px;
      color: #666;
    }

    .follow-btn {
      float: left;
      margin-left: 15px;
      width: 26px;
      height: 24px;
      color: #999;

      &-1 {
        background: url(~@assets/img/icon.png) 0 -696px no-repeat;
      }

      &-2 {
        background: url(~@assets/img/icon.png) 0 -731px no-repeat;
      }

      &-3 {
        background: url(~@assets/img/icon.png) 0 -762px no-repeat;
      }

      &-4 {
        background: url(~@assets/img/icon.png) -2px -794px no-repeat;
      }
    }
  }
}

@keyframes scale {
  0% {
    transform: scale(0.8);
  }

  25% {
    transform: scale(1.1);
  }

  50% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}
</style>
